import axios from 'config/axios'

const QcServices = {
  getSummary: async () => {
    const { data } = await axios.get('admin/qc/summary')
    return data
  },
  getQueue: async (params) => {
    const { data } = await axios.get('admin/qc/queue', { params })
    return data
  },
  getCheck: async (id) => {
    const { data } = await axios.get(`admin/qc/${id}`)
    return data
  },
  start: async (id) => {
    const { data } = await axios.post(`admin/qc/${id}/start`)
    return data
  },
  complete: async (id, formData) => {
    const { data } = await axios.post(`admin/qc/${id}/complete`, formData)
    return data
  },
  fail: async (id, formData) => {
    const { data } = await axios.post(`admin/qc/${id}/fail`, formData)
    return data
  },
  reopen: async (id) => {
    const { data } = await axios.post(`admin/qc/${id}/reopen`)
    return data
  },
}

export default QcServices
